import { useRouter } from 'next/router'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/utils/tw-helpers'
import { PopoverArrow, PopoverPortal } from '@radix-ui/react-popover'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'

import ArrowDownIcon from '@/assets/icons/ic_logic-g-app_arrow-down.svg'
import UserIcon from '@/assets/icons/ic_logic-g-app_portfolio-solid.svg'

interface Props {
  partnerName: string
  handleSignOutClick: () => Promise<void>
}

export const PartnerTopHeaderMenu = ({
  partnerName,
  handleSignOutClick,
}: Props): JSX.Element => {
  const [openMenu, setOpenMenu] = useState(false)
  const router = useRouter()

  return (
    <Popover open={openMenu} onOpenChange={setOpenMenu} modal={true}>
      <PopoverTrigger
        className={cn(
          'flex h-[38px] w-[62px] items-center rounded-[10px] bg-basic-bg px-1 text-[13px] font-bold text-primary-100 md:h-[44px] md:w-[192px] md:px-2.5 lg:h-[46px] lg:text-[13px]',
          openMenu && 'bg-primary-100 text-white'
        )}
        onClick={() => setOpenMenu(!openMenu)}
      >
        <UserIcon width={30} />
        <span className="ml-[2px] hidden truncate md:block">{partnerName}</span>
        <ArrowDownIcon width={28} className="ml-auto shrink-0" />
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          className="border-none p-0"
          align="end"
          onEscapeKeyDown={() => setOpenMenu(false)}
        >
          <div className="w-[304px] rounded-[6px] bg-basic-bg p-[14px] shadow-[0px_2px_2px_#00000026]">
            <div className="flex gap-2 rounded-[6px] bg-white p-[10px]">
              <div className="flex min-w-0 flex-1 flex-col justify-center overflow-hidden pl-[3px] text-xs font-bold leading-normal">
                <p className="text-primary-text">ログイン中</p>
                <p className="truncate text-[10px] text-secondary-text">
                  パートナー管理
                </p>
              </div>
              <div className="shrink-0">
                <Button
                  variant="light"
                  className="h-[38px] w-[84px] items-center justify-center px-2 text-xs"
                  onClick={async () => {
                    await handleSignOutClick()
                    setOpenMenu(false)
                  }}
                >
                  ログアウト
                </Button>
              </div>
            </div>
            <div className="mt-[10px] text-center">
              <Button
                variant="secondary"
                className="h-[38px] min-w-[170px] text-xs"
                onClick={() => {
                  setOpenMenu(false)
                  router.push('/web/partner-admin/password_change')
                }}
              >
                パスワード変更
              </Button>
            </div>
          </div>
          <PopoverArrow className="fill-[#F8F8F8]" />
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  )
}
